import { createFileRoute } from '@tanstack/react-router'
import { PERMISSION_ROLES } from '../../../../src/constants/premissions'
import { billReportParamsSchema, billReportSearchSchema } from '../../../../src/schemas/routeSchemas'
import { requirePermission } from '../../../../src/utils/routePermissions'

export const Route = createFileRoute('/bill/report/$queryId')({
  validateSearch: (search) => billReportSearchSchema.parse(search),
  params: {
    parse: (params) => billReportParamsSchema.parse(params),
  },
  loaderDeps: ({ search }) => ({ isPrintMode: search.isPrintMode }),
  beforeLoad: ({ context }) => {
    requirePermission(context, Route.options.staticData?.permissionRequired)
  },
  staticData: {
    englishAllowed: true,
    permissionRequired: PERMISSION_ROLES.BILL,
  },
})
